import { UPDATE_DRAFT } from 'ducks/drafts2/constants'
import { doFetchCurrentContact } from 'ducks/crm/contacts/operations/fetching/doFetchCurrentContact'
import { CHANGE_CONVERSATION_CONTACT_SUCCESS } from 'ducks/crm/contacts/types'
import { doCreateDraft } from './doCreateDraft'

export function doUpsertReplyDraft(
  draftId,
  draftType,
  ticketId,
  messageId,
  fields
) {
  return dispatch => {
    let retVal
    if (draftId) {
      retVal = dispatch({
        type: UPDATE_DRAFT,
        data: { draftType, draftId, ticketId, fields },
      })
    } else {
      retVal = dispatch(doCreateDraft(ticketId, draftType, fields))
    }
    // This works because only the field that are different come through. If you
    // change that, this will start to fetch too often.
    const toEmail = (fields?.to || [])[0]?.email
    if (toEmail) {
      dispatch(doFetchCurrentContact())
    } else if (fields.to?.length === 0) {
      dispatch({
        type: CHANGE_CONVERSATION_CONTACT_SUCCESS,
        payload: {
          conversationChangeContact: {
            conversation: {
              number: 'new',
              contact: { id: undefined },
            },
          },
        },
      })
    }
    return retVal
  }
}
